<template>
    <b-modal
        class="assignment-edit-preview-modal"
        id="assignment-edit-preview-modal"
        v-model="modal"
        title="Preview"
        :ok-title="$t('common.close')"
        ok-only
        size="xl"
        modal-class="apprentice-default-modal">
        <design-2021-assignment-show-component
            :is-preview="true"
            :group-type-id-in="groupTypeIdIn"
            :assignment-in="assignmentIn">
        </design-2021-assignment-show-component>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-edit-preview-modal-component',
    props: {
        assignmentIn: {
            type: Object,
            required: true,
        },
        groupTypeIdIn: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            modal: false,
        };
    },
    methods: {
        show() {
            this.modal = true;
        },
    },
};
</script>

<style scoped>

</style>
